import { render } from "./PropertyNonResidential.vue?vue&type=template&id=d639f6d0"
import script from "./PropertyNonResidential.vue?vue&type=script&lang=js"
export * from "./PropertyNonResidential.vue?vue&type=script&lang=js"

import "./PropertyNonResidential.vue?vue&type=style&index=0&id=d639f6d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__